import React, { useEffect, useState } from 'react';
import api from '../../services/api';

const DIAS = ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado', 'Domingo'];

function getLunes(fecha) {
  const d = new Date(fecha);
  const dia = d.getDay();
  const diff = d.getDate() - dia + (dia === 0 ? -6 : 1);
  d.setDate(diff);
  return d;
}

function formatFecha(date) {
  return date.toISOString().split('T')[0];
}

function addDias(date, dias) {
  const d = new Date(date);
  d.setDate(d.getDate() + dias);
  return d;
}

const TIPO_COLORS = {
  servicio: { bg: '#eaf3de', border: '#97c459', color: '#3b6d11' },
  guardia:  { bg: '#e8f0fe', border: '#4285f4', color: '#1a56db' },
  trabajos: { bg: '#faeeda', border: '#ef9f27', color: '#854f0b' },
};

function CeldaTurno({ turnos, editando, valorEdit, setValorEdit, onEdit, onGuardar, setEditando, maquinistas, borrarTurno }) {
  const [sugerencias, setSugerencias] = React.useState([]);

  const onChangeInput = (val) => {
    setValorEdit(val);
    if (val.length >= 1) {
      const filtradas = maquinistas.filter(m =>
        m.nombre_completo.toLowerCase().includes(val.toLowerCase())
      );
      setSugerencias(filtradas.slice(0, 5));
    } else {
      setSugerencias([]);
    }
  };

  const seleccionar = (m) => {
    setValorEdit(m.nombre_completo);
    setSugerencias([]);
  };

  return (
    <td style={{ padding: '3px 4px', verticalAlign: 'top', minWidth: 110 }}>
      {turnos.map(t => (
        <div key={t.id} style={{
          background: TIPO_COLORS[t.tipo]?.bg || '#f0f0f0',
          border: `1px solid ${TIPO_COLORS[t.tipo]?.border || '#ddd'}`,
          borderRadius: 6, padding: '3px 6px', marginBottom: 2, cursor: 'pointer', fontSize: 11
        }} onClick={() => { onEdit(t); setSugerencias([]); }}>
          {t.tipo === 'trabajos' && editando !== t.id && (
              <button onClick={e => { e.stopPropagation(); borrarTurno(t.id); }}
                style={{ float: 'right', border: 'none', background: 'none', cursor: 'pointer', fontSize: 10, color: '#ccc', padding: '0 2px', lineHeight: 1 }}>✕</button>
            )}
          {editando === t.id ? (
            <div onClick={e => e.stopPropagation()} style={{ position: 'relative' }}>
              <input value={valorEdit} onChange={e => onChangeInput(e.target.value)}
                onKeyDown={e => { if (e.key === 'Enter') { onGuardar(t.id); setSugerencias([]); } if (e.key === 'Escape') { setEditando(null); setSugerencias([]); } }}
                autoFocus placeholder="Maquinista..."
                style={{ width: '100%', padding: '2px 4px', border: '1px solid #ddd', borderRadius: 4, fontSize: 11, boxSizing: 'border-box' }} />
              {sugerencias.length > 0 && (
                <div style={{ position: 'absolute', top: '100%', left: 0, right: 0, background: '#fff', border: '1px solid #ddd', borderRadius: 6, zIndex: 200, boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }}>
                  {sugerencias.map(m => (
                    <div key={m.id} onClick={() => seleccionar(m)} style={{
                      padding: '5px 8px', cursor: 'pointer', fontSize: 11,
                      borderBottom: '1px solid #f0f0f0'
                    }} onMouseEnter={e => e.target.style.background = '#f5f5f5'}
                       onMouseLeave={e => e.target.style.background = 'transparent'}>
                      {m.nombre_completo}
                    </div>
                  ))}
                </div>
              )}
              <div style={{ display: 'flex', gap: 3, marginTop: 2 }}>
                <button onClick={() => { onGuardar(t.id); setSugerencias([]); }}
                  style={{ flex: 1, padding: '2px', borderRadius: 4, border: 'none', background: '#1a1a1a', color: '#fff', cursor: 'pointer', fontSize: 10 }}>✓</button>
                <button onClick={() => { setEditando(null); setSugerencias([]); }}
                  style={{ flex: 1, padding: '2px', borderRadius: 4, border: '1px solid #ddd', background: '#fff', cursor: 'pointer', fontSize: 10 }}>✕</button>
              </div>
            </div>
          ) : (
            <span style={{ color: t.maquinista ? TIPO_COLORS[t.tipo]?.color : '#bbb' }}>
              {t.maquinista || 'Sin asignar'}
            </span>
          )}
        </div>
      ))}
    </td>
  );
}

export default function Calendario() {
  const [semanaInicio, setSemanaInicio] = useState(getLunes(new Date()));
  const [datos, setDatos] = useState(null);
  const [loading, setLoading] = useState(true);
  const [generando, setGenerando] = useState(false);
  const [editando, setEditando] = useState(null);
  const [valorEdit, setValorEdit] = useState('');
  const [filtroLote, setFiltroLote] = useState('');
  const [filtroBase, setFiltroBase] = useState('');
  const [maquinistas, setMaquinistas] = useState([]);

  useEffect(() => {
    api.get('/planificacion/maquinistas-disponibles').then(r => setMaquinistas(r.data)).catch(() => {});
  }, []);
  const [menuExportar, setMenuExportar] = useState(false);
  const [menuTrabajos, setMenuTrabajos] = useState(null);

  useEffect(() => { cargar(); }, [semanaInicio]);

  const cargar = () => {
    setLoading(true);
    api.get(`/planificacion/semana?fecha_inicio=${formatFecha(semanaInicio)}`)
      .then(r => setDatos(r.data))
      .finally(() => setLoading(false));
  };

  const cambiarSemana = (semanas) => {
    const nueva = new Date(semanaInicio);
    nueva.setDate(nueva.getDate() + semanas * 7);
    setSemanaInicio(nueva);
  };

  const generarSemana = async () => {
    setGenerando(true);
    try {
      await api.post(`/planificacion/generar-semana?fecha_inicio=${formatFecha(semanaInicio)}`);
      cargar();
    } finally {
      setGenerando(false);
    }
  };

  const guardarMaquinista = async (id) => {
    await api.patch(`/planificacion/${id}`, { maquinista: valorEdit });
    setEditando(null);
    cargar();
  };

  const borrarTurno = async (id) => {
    if (!window.confirm('¿Eliminar este turno?')) return;
    await api.delete(`/planificacion/${id}`);
    cargar();
  };

  const añadirTrabajos = async (base, fecha) => {
    const tipoTrabajos = datos?.tipos?.find(t => t.tipo === 'trabajos');
    if (!tipoTrabajos) return;
    await api.post('/planificacion/', {
      fecha: fecha || formatFecha(semanaInicio),
      base,
      turno_tipo_id: tipoTrabajos.id,
      maquinista: null
    });
    cargar();
  };

  const exportar = async (formato) => {
    const token = localStorage.getItem('token');
    const url = `/api/exportar-calendario/${formato}?fecha_inicio=${formatFecha(semanaInicio)}`;
    const r = await fetch(url, { headers: { 'Authorization': `Bearer ${token}` } });
    const blob = await r.blob();
    const a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = `calendario_${formatFecha(semanaInicio)}.${formato === 'excel' ? 'xlsx' : 'pdf'}`;
    a.click();
    setMenuExportar(false);
  };

  const diasSemana = Array.from({ length: 7 }, (_, i) => addDias(semanaInicio, i));

  // Agrupar por lote → base → servicio/turno
  const agrupar = () => {
    if (!datos) return {};
    const estructura = {};
    datos.planificacion.forEach(p => {
      const lote = p.lote || 'Sin lote';
      const base = p.base_nombre || p.base || 'Sin base';
      const label = p.servicio_codigo || p.turno_nombre;
      if (!estructura[lote]) estructura[lote] = {};
      if (!estructura[lote][base]) estructura[lote][base] = {};
      if (!estructura[lote][base][label]) estructura[lote][base][label] = { tipo: p.tipo, dias: {} };
      if (!estructura[lote][base][label].dias[p.fecha]) estructura[lote][base][label].dias[p.fecha] = [];
      estructura[lote][base][label].dias[p.fecha].push(p);
    });
    return estructura;
  };

  const estructura = agrupar();
  const lotes = Object.keys(estructura).sort();

  // Obtener todas las bases para el filtro
  const todasLasBases = [...new Set(datos?.planificacion?.map(p => p.base).filter(Boolean))].sort();

  return (
    <div>
      <div style={{ marginBottom: 20, display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 10 }}>
        <div>
          <h2 style={{ fontSize: 22, fontWeight: 500, margin: 0 }}>Calendario</h2>
          <p style={{ fontSize: 13, color: '#888', marginTop: 4 }}>Planificación semanal de maquinistas</p>
        </div>
        <div style={{ display: 'flex', gap: 8 }}>
          <button onClick={generarSemana} disabled={generando}
            style={{ padding: '8px 16px', borderRadius: 8, border: 'none', background: '#1a1a1a', color: '#fff', cursor: 'pointer', fontSize: 13, opacity: generando ? 0.6 : 1 }}>
            {generando ? 'Generando...' : '⚡ Generar semana'}
          </button>
          <div style={{ position: 'relative' }}>
            <button onClick={() => setMenuExportar(!menuExportar)}
              style={{ padding: '8px 16px', borderRadius: 8, border: '1px solid #ddd', background: '#fff', cursor: 'pointer', fontSize: 13 }}>
              📥 Exportar ▾
            </button>
            {menuExportar && (
              <div style={{ position: 'absolute', right: 0, top: '100%', marginTop: 4, background: '#fff', border: '1px solid #ddd', borderRadius: 8, boxShadow: '0 4px 12px rgba(0,0,0,0.1)', zIndex: 100, minWidth: 140 }}>
                <button onClick={() => exportar('excel')}
                  style={{ display: 'block', width: '100%', padding: '10px 16px', border: 'none', background: 'none', cursor: 'pointer', fontSize: 13, textAlign: 'left' }}>
                  📊 Excel
                </button>
                <button onClick={() => exportar('pdf')}
                  style={{ display: 'block', width: '100%', padding: '10px 16px', border: 'none', background: 'none', cursor: 'pointer', fontSize: 13, textAlign: 'left', borderTop: '1px solid #f0f0f0' }}>
                  📄 PDF
                </button>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Navegador semana */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 16, flexWrap: 'wrap' }}>
        <button onClick={() => cambiarSemana(-1)}
          style={{ width: 32, height: 32, borderRadius: '50%', border: '1px solid #ddd', background: '#fff', cursor: 'pointer', fontSize: 16 }}>‹</button>
        <span style={{ fontWeight: 500, fontSize: 15 }}>
          {semanaInicio.toLocaleDateString('es-ES', { day: 'numeric', month: 'long' })} — {addDias(semanaInicio, 6).toLocaleDateString('es-ES', { day: 'numeric', month: 'long', year: 'numeric' })}
        </span>
        <button onClick={() => cambiarSemana(1)}
          style={{ width: 32, height: 32, borderRadius: '50%', border: '1px solid #ddd', background: '#fff', cursor: 'pointer', fontSize: 16 }}>›</button>
        <button onClick={() => setSemanaInicio(getLunes(new Date()))}
          style={{ padding: '4px 12px', borderRadius: 8, border: '1px solid #ddd', background: '#fff', cursor: 'pointer', fontSize: 12, color: '#555' }}>Hoy</button>

        {/* Filtros */}
        <div style={{ display: 'flex', gap: 6, marginLeft: 8 }}>
          {[['', 'Todos'], ['lote1', 'Lote 1'], ['lote2', 'Lote 2']].map(([val, label]) => (
            <button key={val} onClick={() => setFiltroLote(val)} style={{
              padding: '4px 12px', borderRadius: 8, border: 'none', cursor: 'pointer', fontSize: 12, fontWeight: 500,
              background: filtroLote === val ? '#1a1a1a' : '#f0f0f0',
              color: filtroLote === val ? '#fff' : '#555'
            }}>{label}</button>
          ))}
          {todasLasBases.length > 0 && (
            <select value={filtroBase} onChange={e => setFiltroBase(e.target.value)}
              style={{ padding: '4px 10px', borderRadius: 8, border: '1px solid #ddd', fontSize: 12, background: '#fff' }}>
              <option value="">Todas las bases</option>
              {todasLasBases.map(b => <option key={b} value={b}>{b}</option>)}
            </select>
          )}
        </div>
      </div>

      {loading ? (
        <div style={{ padding: 40, color: '#888', textAlign: 'center' }}>Cargando...</div>
      ) : (
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12, minWidth: 900 }}>
            <thead>
              <tr style={{ background: '#f8f8f6' }}>
                <th style={{ padding: '10px 12px', textAlign: 'left', fontWeight: 500, color: '#555', width: 200, borderBottom: '2px solid #e5e5e5' }}>
                  Lote / Base / Turno
                </th>
                {diasSemana.map((d, i) => (
                  <th key={i} style={{
                    padding: '10px 8px', textAlign: 'center', fontWeight: 500, color: '#555',
                    borderBottom: '2px solid #e5e5e5',
                    background: d.toDateString() === new Date().toDateString() ? '#fef9e7' : '#f8f8f6'
                  }}>
                    <div>{DIAS[i]}</div>
                    <div style={{ fontSize: 11, color: '#888', fontWeight: 400 }}>
                      {d.toLocaleDateString('es-ES', { day: 'numeric', month: 'short' })}
                    </div>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {lotes.length === 0 ? (
                <tr>
                  <td colSpan={8} style={{ padding: 40, textAlign: 'center', color: '#888' }}>
                    No hay turnos. Dale a "⚡ Generar semana" para crear los turnos automáticamente.
                  </td>
                </tr>
              ) : lotes.filter(l => !filtroLote || l === filtroLote).map(lote => {
                const bases = Object.keys(estructura[lote]).sort()
                  .filter(b => !filtroBase || b === filtroBase);
                if (bases.length === 0) return null;

                return (
                  <React.Fragment key={lote}>
                    {/* Cabecera de lote */}
                    <tr>
                      <td colSpan={8} style={{
                        padding: '10px 12px', fontWeight: 700, fontSize: 14,
                        background: '#1a1a1a', color: '#fff',
                        letterSpacing: 1, textTransform: 'uppercase'
                      }}>
                        {lote === 'lote1' ? 'Lote 1' : lote === 'lote2' ? 'Lote 2' : lote}
                      </td>
                    </tr>

                    {bases.map(base => {
                      const servicios = estructura[lote][base];
                      const filas = Object.keys(servicios).sort((a, b) => {
                        const orden = { servicio: 0, guardia: 1, trabajos: 2 };
                        return (orden[servicios[a].tipo] || 0) - (orden[servicios[b].tipo] || 0);
                      });

                      return (
                        <React.Fragment key={base}>
                          {/* Cabecera de base */}
                          <tr>
                            <td colSpan={8} style={{
                              padding: '6px 12px', fontWeight: 600, fontSize: 12,
                              background: '#f0f0f0', borderTop: '1px solid #ddd', color: '#333'
                            }}>
                              📍 {base}
                            </td>
                          </tr>

                          {/* Filas de turnos */}
                          {filas.map(label => {
                            const fila = servicios[label];
                            return (
                              <tr key={label} style={{ borderBottom: '1px solid #f5f5f5' }}>
                                <td style={{ padding: '4px 12px 4px 28px', verticalAlign: 'middle' }}>
                                  <span style={{
                                    display: 'inline-block', padding: '2px 8px', borderRadius: 20, fontSize: 11,
                                    background: TIPO_COLORS[fila.tipo]?.bg || '#f0f0f0',
                                    color: TIPO_COLORS[fila.tipo]?.color || '#555',
                                    border: `1px solid ${TIPO_COLORS[fila.tipo]?.border || '#ddd'}`
                                  }}>
                                    {label}
                                  </span>
                                </td>
                                {diasSemana.map((d, di) => {
                                  const diaKey = formatFecha(d);
                                  const turnos = fila.dias[diaKey] || [];
                                  return (
                                    <CeldaTurno key={di}
                                      turnos={turnos}
                                      editando={editando}
                                      valorEdit={valorEdit}
                                      setValorEdit={setValorEdit}
                                      onEdit={t => { setEditando(t.id); setValorEdit(t.maquinista || ''); }}
                                      onGuardar={guardarMaquinista}
                                      setEditando={setEditando}
                                      maquinistas={maquinistas}
                                      borrarTurno={borrarTurno}
                                    />
                                  );
                                })}
                              </tr>
                            );
                          })}

                          {/* Botón añadir tren de trabajos */}
                          <tr>
                            <td colSpan={8} style={{ padding: '2px 12px 6px 28px' }}>
                              <div style={{ position: 'relative', display: 'inline-block' }}>
                                <button onClick={() => setMenuTrabajos(menuTrabajos === base ? null : base)}
                                  style={{ padding: '3px 10px', borderRadius: 6, border: '1px dashed #ccc', background: '#fff', cursor: 'pointer', fontSize: 11, color: '#888' }}>
                                  + Añadir tren de trabajos
                                </button>
                                {menuTrabajos === base && (
                                  <div style={{ position: 'absolute', top: '100%', left: 0, background: '#fff', border: '1px solid #e5e5e5', borderRadius: 8, boxShadow: '0 4px 12px rgba(0,0,0,0.1)', zIndex: 100, padding: 6, display: 'flex', gap: 4 }}>
                                    {diasSemana.map((d, di) => (
                                      <button key={di} onClick={() => { añadirTrabajos(base, formatFecha(d)); setMenuTrabajos(null); }}
                                        style={{ padding: '4px 8px', borderRadius: 6, border: '1px solid #e5e5e5', background: '#f8f8f8', cursor: 'pointer', fontSize: 11, color: '#555', fontWeight: 500 }}>
                                        {['L','M','X','J','V','S','D'][di]}
                                      </button>
                                    ))}
                                  </div>
                                )}
                              </div>
                            </td>
                          </tr>
                        </React.Fragment>
                      );
                    })}
                  </React.Fragment>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
